(() => {
  if (!customElements.get('kaipet-coupon')) {
    customElements.define('kaipet-coupon', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelector('button[data-code]')?.addEventListener('click', async (event) => {
          const button = event.currentTarget;
          let copied = false;
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            copied = true;
          } catch {
            const field = document.createElement('textarea');
            field.value = button.dataset.code;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            this.append(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch { copied = false; }
            field.remove();
            button.focus({ preventScroll: true });
          }
          const status = this.querySelector('[role="status"]');
          status.textContent = copied ? button.dataset.copied : button.dataset.failed;
          status.setAttribute('data-visible', '');
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => {
            status.removeAttribute('data-visible');
            status.textContent = '';
          }, 3000);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.statusTimer);
      }
    });
  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Madrid';
  const localParts = (date) => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date);
    return Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  };
  const addDays = (date, count, skipWeekends, skipSaturday = true) => {
    const result = new Date(date);
    const validDay = () => !skipWeekends || (result.getUTCDay() !== 0 && (!skipSaturday || result.getUTCDay() !== 6));
    while (!validDay()) result.setUTCDate(result.getUTCDate() + 1);
    for (let days = 0; days < count;) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (validDay()) days++;
    }
    return result;
  };
  const calendar = (now, options) => {
    const p = localParts(now);
    const today = new Date(Date.UTC(p.year, p.month - 1, p.day));
    const cutoffAdjustment = options.cutoff > 0 && p.hour >= options.cutoff ? 1 : 0;
    const shipping = addDays(today, options.preparation + cutoffAdjustment, options.skipWeekends);
    const delivery = addDays(shipping, options.transit, options.skipWeekends, false);
    return { shipping, shippingEnd: addDays(shipping, options.buffer, options.skipWeekends), delivery,
      deliveryEnd: addDays(delivery, options.buffer, options.skipWeekends, false), p };
  };
  const cutoffInstant = (now, cutoff) => {
    const p = localParts(now);
    const local = new Date(Date.UTC(p.year, p.month - 1, p.day, cutoff));
    if (p.hour >= cutoff) local.setUTCDate(local.getUTCDate() + 1);
    const wall = local.getTime();
    let instant = wall;
    for (let i = 0; i < 3; i++) {
      const z = localParts(new Date(instant));
      const observed = Date.UTC(z.year, z.month - 1, z.day, z.hour, z.minute, z.second);
      instant += wall - observed;
    }
    return instant;
  };
  if (!customElements.get('kaipet-delivery')) {
    customElements.define('kaipet-delivery', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      update() {
        const now = new Date();
        const options = {
          preparation: Number(this.dataset.preparation), transit: Number(this.dataset.transit),
          buffer: Number(this.dataset.buffer), cutoff: Number(this.dataset.cutoff),
          skipWeekends: this.dataset.skipWeekends === 'true'
        };
        const dates = calendar(now, options);
        const format = new Intl.DateTimeFormat(this.dataset.locale || 'es-ES', { day: 'numeric', month: 'long', timeZone: 'UTC' });
        const range = (start, end) => start.getTime() === end.getTime() ? format.format(start) : `${format.format(start)} -\n${format.format(end)}`;
        this.querySelector('[data-shipping-date]').textContent = range(dates.shipping, dates.shippingEnd);
        this.querySelector('[data-delivery-date]').textContent = range(dates.delivery, dates.deliveryEnd);
        const countdown = this.querySelector('[data-countdown]');
        if (countdown) {
          const minutes = Math.max(0, Math.floor((cutoffInstant(now, options.cutoff) - now.getTime()) / 60000));
          const number = new Intl.NumberFormat(this.dataset.locale || 'es-ES', { minimumIntegerDigits: 2 });
          countdown.textContent = `${number.format(Math.floor(minutes / 60))} ${this.dataset.hours} ${number.format(minutes % 60)} ${this.dataset.minutes}`;
          countdown.parentElement.hidden = false;
        }
      }
    });
  }
})();
